import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { HeaderItem } from 'components/misc'
import { MyLeaderModal } from 'components/modals'
import { apiDashboard } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import styles from './my-leader.styl'

@apiDashboard.apiAwards()
@modal.trigger()
class MyLeader extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    awards: PropTypes.object,
    onlyTrigger: PropTypes.bool
  }

  handleOpenNotifications = () =>
    this.props.onOpen(MODALS.MY_LEADER, null, null)

  render() {
    const { awards, onlyTrigger } = this.props

    return (
      <div className={styles.wrap}>
        <HeaderItem
          ico="face"
          caption="My Award Leader"
          captionKey="label.my_award_leader"
          onClick={this.handleOpenNotifications}
        />

        {!onlyTrigger && (
          <MyLeaderModal
            modalId={MODALS.MY_LEADER}
            leader={get(awards, 'data.awardLeader')}
          />
        )}
      </div>
    )
  }
}

export default MyLeader
